import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "trash",
  "use": "trash-usage",
  "viewBox": "0 0 15 18",
  "content": "<symbol viewBox=\"0 0 15 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"trash\"><path d=\"M1.317 18H13.61V3.512H1.317V18zm4.17-18l-.466 1.317H0v1.317h14.927V1.317H9.87L9.44 0H5.488z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/trash.svg
// module id = 595
// module chunks = 0